// Mirrors backend/src/core/comms/types.ts `dmChannelId()` exactly. This is
// what lets a client navigate to (and later lazily create) a DM thread
// before the backend has ever persisted it — see CommsPage's virtual-channel
// resolution and ChatSocketProvider's lazy-create-on-first-send. Any change
// to the backend's id format must be mirrored here.

export function dmChannelId(siteId: string, userA: string, userB: string): string {
  return `dm:${siteId}:${[userA, userB].sort().join('|')}`;
}

/**
 * Recovers "the other participant" from a DM channel id, given the current
 * user's id. Returns null for anything that isn't a `dmChannelId`-shaped id
 * for this site (a group channel id, an id from another site) or where the
 * current user isn't one of the two participants embedded in it.
 */
export function otherDmMemberId(
  channelId: string,
  siteId: string,
  currentUserId: string,
): string | null {
  const prefix = `dm:${siteId}:`;
  if (!channelId.startsWith(prefix)) return null;
  const [a, b] = channelId.slice(prefix.length).split('|');
  if (!a || !b) return null;
  if (a === currentUserId) return b;
  if (b === currentUserId) return a;
  return null;
}
